import { React, useState } from 'react';
import { Button } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Watchlist } from '../../services/Contexture/Watchlist';
import { toast } from 'react-toastify';

library.add(fal);

const WatchListRemoveButton = ({ profileId, docId }) => {
  const [watch, setWatch] = useState(false);
  const handleClick = async (e) => {
    try {
      const response = await Watchlist.removeDocument(docId, { profileId });

      if (response !== null && response !== undefined) {
        setWatch(true);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('refreshDocLists'));
        }
        toast.success('Removed from watchlist', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error('Failed to remove from watchlist', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <Button
      variant='text'
      onClick={() => handleClick()}
      className='remove-watchlist remove-btn'
      title='Remove from Watchlist'
    >
      <FontAwesomeIcon
        icon={watch ? ['fal', 'check'] : ['fal', 'file-times']}
      ></FontAwesomeIcon>
    </Button>
  );
};
export default WatchListRemoveButton;
